class ArtistFilters extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.categoryFilterKeys = ['new-artworks', 'new-artists', 'canadian-masters'];
    this.filters = Array.from(this.querySelectorAll('button[data-filter]'));
    this.items = Array.from(this.querySelectorAll('[data-item]'));
    this.bindEvents();
    this.updateFilters();
  }

  bindEvents() {
    this.filters.forEach(filter => {
      filter.addEventListener('click', (event) => {
        event.preventDefault();

        if (filter.classList.contains('is-disabled')) {
          return;
        }

        this.activateFilter(filter);
      });
    });
  }

  deactivateAlphaFilters() {
    const alphaFilters = this.filters.filter((filter) => filter.dataset.filter.length === 1);

    alphaFilters.forEach(alphaFilter => {
      alphaFilter.classList.remove('is-active');
    });
  }

  activateFilter(filter) {
    const filterKey = filter.dataset.filter;

    this.deactivateAlphaFilters();

    if (filter.classList.contains('is-active')) {
      filter.classList.remove('is-active');
    } else {
      filter.classList.add('is-active');
    }

    this.filterItems();

    // Only update filters if a category filter is clicked
    if (this.categoryFilterKeys.includes(filterKey)) {
      this.updateFilters();
    }
  }

  filterItems() {
    const activeFilters = this.getActiveFilters();

    this.items.forEach(item => {
      const showItem = activeFilters.every(filterKey =>
        this.doesItemMatchFilter(item, filterKey)
      );

      item.style.display = showItem ? 'block' : 'none';
    });
  }

  updateFilters() {
    const activeFilters = this.getActiveFilters();

    this.filters.forEach(filter => {
      const filterKey = filter.dataset.filter;

      const isFilterActive = filter.classList.contains('is-active');
      const isAlphaFilter = (filterKey.length === 1);

      if (isAlphaFilter && isFilterActive) {
        return;
      }

      const otherActiveFilters = activeFilters.filter(key => key !== filterKey);
      const isFilterSelectable = this.items.some(item =>
        [...otherActiveFilters, filterKey].every(filterKey => this.doesItemMatchFilter(item, filterKey))
      );

      if (!isFilterSelectable) {
        filter.classList.add('is-disabled');
      } else {
        filter.classList.remove('is-disabled');
      }
    });
  }

  doesItemMatchFilter(item, filterKey) {
    const alpha = item.dataset.alpha;

    const isNewProduct = item.dataset.artworks === '1';
    const isNewCollection = item.dataset.new === '1';
    const isTop = item.dataset.top === '1';

    if (filterKey === 'new-artworks') return isNewProduct;
    if (filterKey === 'new-artists') return isNewCollection;
    if (filterKey === 'canadian-masters') return isTop;
    if (filterKey === '#') return !/[A-Z]/.test(alpha);
    if (filterKey.length === 1) return (alpha === filterKey); // Filter by alpha letter

    return false;
  }

  getActiveFilters() {
    return this.filters
      .filter(filter => filter.classList.contains('is-active'))
      .map(filter => filter.dataset.filter);
  }
}

customElements.define('artist-filters', ArtistFilters);
